<mat-dialog-content>
  <p *ngIf="!message">
    {{'dialogs.aggregateVersionError.message' | translate}}
  </p>

  <p *ngIf="message">
    {{message}}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center">

  <button mat-dialog-close color="primary" mat-raised-button tabindex="1">
    {{'dialogs.aggregateVersionError.buttonText' | translate}}
  </button>

</mat-dialog-actions>
